/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateAdminDto } from '../../models/create-admin-dto';
import { ResponseAdminDto } from '../../models/response-admin-dto';

export interface AdminsControllerCreate$Params {
      body: CreateAdminDto
}

export function adminsControllerCreate(http: HttpClient, rootUrl: string, params: AdminsControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponseAdminDto>> {
  const rb = new RequestBuilder(rootUrl, adminsControllerCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ResponseAdminDto>;
    })
  );
}

adminsControllerCreate.PATH = '/thalea-admins/admins';
